// import Vue from 'vue';
import axios from 'axios';
import CryptoJS from '../commons/crypto.js';
import apis from './modules';
import cookie from '../commons/cookie.js';
import { ElMessage } from 'element-plus';

const logoutUtil = () => {
    cookie.clear('token');
    localStorage.removeItem('userinfo');
    location.href = '/login';
};
/**
 * 请求拦截器
 */
axios.interceptors.request.use(
    function (config) {
        config.timeout = 60000;
        config.headers.Authorization = cookie.getCookie('token');
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

/**
 * 封装http请求函数
 * @param {请求名称} name
 * @param {接口入参} data
 */
const request = function (name = '', data = {}) {
    let {
        url,
        method = 'post',
        header = {
            'content-type': 'application/json'
        },
        pem = false,
        sld = true,
        responseType
    } = getApi(name);
    const headers = getHeader(header, data);

    const item = {
        pem,
        sld,
        url,
        headers,
        method,
        data,
        responseType
    };

    if (item.method.toUpperCase() === 'GET' || item.method.toUpperCase() === 'DELETE') {
        item.params = item.data;
    }

    return new Promise(resolve => {
        axios(item)
            .then(resp => {
                successHandler(resp, resolve);
            })
            .catch(err => {
                errorHandler(err.response);
            });
    });
};

/**
 * 接口处理
 * @param resp
 * @param resolve
 */
function successHandler(resp, resolve) {
    if (resp.request.responseType === 'arraybuffer') {
        resolve(resp);
    } else {
        if (resp.data.status === 200 || resp.config.pem) {
            resolve(resp.data);
        } else if (resp.data.status === 403) {
            if (location.pathname !== '/login') {
                logoutUtil();
            }
        } else {
            errorHandler(resp);
        }
    }
}

/**
 * 错误接口处理
 * @param error
 */
function errorHandler(resp) {
    const message = resp && resp.data ? `${resp.data.message || resp.data.msg || '系统异常'}` : '异常信息：系统异常';
    ElMessage.error(message);
}

/**
 * 封装请求头部信息
 * @param {头部信息} header
 * @param {接口入参} data
 */
const getHeader = function (header, data) {
    const reqtime = Date.now();
    const sign = getSign(reqtime, data);
    const token = cookie.getCookie('token') || '';
    const target = {
        token,
        reqtime,
        sign
    };
    return Object.assign({}, target, header);
};

/**
 * 封装接口秘钥
 * @param {时间戳} reqtime
 * @param {接口入参} data
 */
const getSign = function (reqtime, data) {
    const p = 'guoquan.com#2020|' + reqtime + '|' + JSON.stringify(data);
    const s = CryptoJS.MD5(p).toString();
    return s;
};

/**
 * 获取请求信息
 * @param {请求名称} name
 */
const getApi = function (name) {
    const api = apis.filter(v => {
        return v.name === name;
    });
    if (api.length === 0) {
        throw new Error(`未找到${name}对应的API服务地址`);
    } else {
        return api[0];
    }
};

export default request;
